import { createTheme } from "@mui/material/styles";

//https://mui.com/material-ui/customization/palette/#custom-colors
export const lightBeeTheme = createTheme({
    palette: {
        primary: {
            main: "#333", //top bar icons
        },
        secondary: {
            main: "#333", //item icons
        }
    },
    bee: {
        backgroundSize: "100px",
        barBackgroundDark: "#cca300ff",
        barBackground: "#ffcc00",
        barBackgroundLight: "#ffd324ff",
        contentBackground: "#ddd",

        text: "#000",

        highlightBorder: "#ffcc00",
        darkBorder: "#000",

        backgroundBlendMode: "",
        backgroundImage: `url(${process.env.PUBLIC_URL}/honeycomb-80.png)`,
        backgroundOpacity: 0.7,
    },
});

declare module "@mui/material/styles" {
    interface Theme {
        bee: {
            backgroundSize: string;
            barBackgroundDark: string;
            barBackground: string;
            barBackgroundLight: string;
            contentBackground: string;
            text: string;

            highlightBorder: string;
            darkBorder: string;

            backgroundBlendMode: string;
            backgroundImage: string;
            backgroundOpacity: number;
        };
    }
    interface ThemeOptions {
        bee?: {
            backgroundSize?: string;
            barBackgroundDark?: string;
            barBackground?: string;
            barBackgroundLight?: string;
            contentBackground?: string;
            text?: string;

            highlightBorder?: string;
            darkBorder?: string;

            backgroundBlendMode?: string;
            backgroundImage?: string;
            backgroundOpacity?: number;
        };
    }
}
